import React, {useState} from 'react';

import styles from './Support.module.scss';
import support from "../../constants/images/order-cancelled.svg";
import SupportCategoryModal from "../SupportCategoryModal/SupportCategoryModal";

const Support = ({orderId}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <div className={styles.support}>
            <img src={support} alt="tech support logo"/>
            <div className={styles.support_description}>
                <p className={styles.support_description_title}>Виникли
                    проблеми?</p>
                <p className={styles.support_description_subtitle}>Якщо
                    у вас виникла проблема чи з'явились запитання щодо роботи нашої компанії,
                    зверніться до служби підтримки.</p>
                <button
                    className={styles.support_description_cta}
                    onClick={() => setIsModalOpen(true)}
                >
                    Створити звернення
                </button>
            </div>

            <SupportCategoryModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                orderId={orderId || null}
            />
        </div>
    );
};

export default Support;
